export enum CommunicationTabs {
  MESSAGING = "MESSAGING",
  HISTORY = "HISTORY",
}
